import layout from '@/component/base/layout'
import upload from '@/component/base/upload'
import confirmButton from '@/component/base/confirmButton'
import {
  emailRegExp,
  phoneRegExp,
  normalCarRegExp,
  energyCarRegExp
} from '@/common/regExp'

export default {
  data() {
    return {
      /**
       * CAR_CERTIFICATE_TYPE
       *
       */
      certificateTypeList: [],
      certificateType: {},
      /** CAR_LICENSE_PLATE_TYPE
        BLUE(0, "蓝牌", "蓝牌"),
        YELLOW(1, "黄牌", "黄牌"),
        BLACK(2, "黑牌", "黑牌"),
        SMALL_GREEN(3, "小型新能源车号牌", "小型新能源车号牌"),
        BIG_GREEN(4, "大型新能源车号牌", "大型新能源车号牌");
       */
      licenseTypeList: [],
      /** CAR_TYPE
        TRUCK(0, "货车", "货车"),
        SMALL_NORMAL_BUS(1, "小型普通客车", "小型普通客车"),
        SMALL_SUV(2, "小型越野客车", "小型越野客车"),
        SMALL_CAR(3, "小型轿车", "小型轿车"),
        SMALL_SPECIAL_BUS(4, "小型专用客车", "小型专用客车"),
        MINI_NORMAL_BUS(5, "微型普通客车", "微型普通客车"),
        MINI_SUV(6, "微型越野客车", "微型越野客车");
       */
      carTypeList: [],
      exhibitionId: sessionStorage.getItem('exhibitionId'),
      formRules: {
        producerName: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入公司名称')
        }],
        email: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入邮箱')
        },
        {
          pattern: emailRegExp,
          message: this.$t('carLicenseApply.请输入有效的邮箱'),
          trigger: 'blur'
        }
        ],
        contactName: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入收件人姓名')
        }],
        phone: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入联系电话')
        },
        {
          pattern: phoneRegExp,
          message: this.$t('carLicenseApply.请输入正确的联系方式'),
          trigger: 'blur'
        }
        ],
        carBoothList: [{
          required: true,
          validator: this.validBoothList
        }],
        postAddress: [{
          required: true,
          validator: this.validAddress
        }],
        // contactList
        contactCarBooth: [{
          required: true,
          validator: this.validContactCarBooth
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('constructionPermit.请输入姓名')
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入联系电话')
        },
        {
          pattern: phoneRegExp,
          message: this.$t('carLicenseApply.请输入正确的联系方式'),
          trigger: 'blur'
        }
        ],
        carNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('carLicenseApply.请输入正确的车牌号')
        },
        {
          pattern: normalCarRegExp || energyCarRegExp,
          message: this.$t('carLicenseApply.请输入正确的车牌号'),
          trigger: 'blur'
        }
        ]
      }
    }
  },
  methods: {
    addTableForm(ruleForm) {
      ruleForm.contactList.push({
        id: new Date().getTime(),
        name: '',
        mobile: '',
        carNo: '',
        licenseType: '',
        carType: '',
        idCardFileList: [],
        idCardImageId: '',
        driverFileList: [],
        driverLicenseImageId: '',
        drivingFileList: [],
        steerImageId: '',
        remarks: '',
        contactCarBooth: [],
        carBooth: {}
      })
    },
    exhibitionConfig(type) {
      return new Promise(resolve => {
        this.$http.get(`${this.api}a/api/exhibitionConfig/get?expoid=${this.exhibitionId}&configType=${type}`).then(res => {
          if (res.data.resultCode === 0 || res.data.resultCode === '0') {
            resolve({
              type: type,
              expoConfigs: res.data.data.expoConfigs
            })
          }
        })
      })
    },
    validBoothList(rule, value, callback) {
      if (this.validArray(value)) {
        callback()
      } else {
        callback(this.$t('carLicenseApply.请在下方表格中添加展位号'))
      }
    },
    validContactCarBooth(rule, value, callback) {
      if (this.validArray(value)) {
        callback()
      } else {
        callback(this.$t('constructionPermit.请输入展位号'))
      }
    },
    validAddress(rule, value, callback) {
      if (this.validArray(value)) {
        callback()
      } else {
        callback(this.$t('invoice_apply.form_recipient_address_check'))
      }
    },
    validArray(arr) {
      let result = true
      if (arr.length === 0) {
        result = false
      }
      arr.map(item => {
        if (!item) {
          result = false
        }
      })
      return result
    },
    getExConfigParam(isTruck, isLocal) {
      return `VEHICLE_CAR_${isLocal ? 'LOCAL' : 'NON_LOCAL'}`
    },
    getEnum(type) {
      /**
       * 车辆类型: CAR_TYPE
       * 车证类型: CAR_CERTIFICATE_TYPE
       * 车牌类型: CAR_LICENSE_PLATE_TYPE
       */
      return new Promise(resolve => {
        this.$http.get(`${this.api}a/api/sys/rest/dict/dictList/${type}`)
          .then(res => {
            resolve(res.data)
          })
      })
    },
    getLicenseTypeList() {
      this.getEnum('CAR_LICENSE_PLATE_TYPE').then(res => {
        this.licenseTypeList = res
      })
    },
    getCarTypeList() {
      this.getEnum('CAR_TYPE').then(res => {
        this.carTypeList = res
      })
    },
    getCertificateTypeList() {
      this.getEnum('CAR_CERTIFICATE_TYPE').then(res => {
        this.certificateTypeList = res
        this.certificateTypeList.map(item => {
          if (item.value === 'NORMAL') {
            this.certificateType = {
              label: item.label,
              value: item.value
            }
          }
        })
      })
    }

  },
  components: {
    layout,
    upload,
    confirmButton
  }
}



// WEBPACK FOOTER //
// ./src/mixins/carLicense/carLicense.js